export default __webpack_public_path__ + "static/media/Slider-2.ea48d6bc.png";